<div>Hi ha hagut un error inesperat al servidor. Torni-ho a intentar mes endevant</div>
<button  class="text" mat-button color="primary" (click)="close()">
    Tancar
</button>